package songwritersnotebook.app.utils

/**
 * Simple syllable counting function for KMP
 * This is a basic implementation - can be improved later
 */
fun countSyllables(text: String): Int {
    if (text.isBlank()) return 0
    
    val cleanText = text.lowercase().trim()
    
    // Basic rules for syllable counting
    var syllableCount = 0
    
    // Count vowel groups as syllables
    val vowelGroups = Regex("[aeiouy]+", RegexOption.IGNORE_CASE)
    val matches = vowelGroups.findAll(cleanText)
    syllableCount += matches.count()
    
    // Subtract silent e at the end
    if (cleanText.endsWith("e") && !cleanText.endsWith("le")) {
        syllableCount--
    }
    
    // Add syllable for words ending in "le" that are not silent
    if (cleanText.endsWith("le") && !cleanText.matches(Regex(".*[aeiouy]le$"))) {
        syllableCount++
    }
    
    // Handle some common exceptions
    if (cleanText.startsWith("re") && cleanText.length > 3) {
        syllableCount++ // words like "return", "reaction"
    }
    
    return maxOf(1, syllableCount)
}
